import { useMutation } from '@tanstack/react-query'

import type { TGetSimulacaoDuplicarResponse } from '@/features/simulacao/interfaces'
import { GetSimulacaoDuplicarService } from '@/features/simulacao/services/get-simulacao-duplicar.service'
import {
  isSimulacaoErrorCode,
  getSimulacaoErrorMessage,
  type SimulacaoErrorCode,
} from '@/features/simulacao/utils/error-messages'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'
import { showToast } from '@/shared/lib/sonner'
import { assertErrorResponse } from '@/shared/utils/assert-error-response'

export const useGetSimulacaoDuplicar = () => {
  return useMutation<TGetSimulacaoDuplicarResponse, AxiosErrorMap<SimulacaoErrorCode>, string>({
    mutationFn: async (simulacaoId: string) => {
      const response = await new GetSimulacaoDuplicarService().execute(simulacaoId)
      return response.data
    },
    onError: (error) => {
      assertErrorResponse(error)
      const apiError = error.response.data.find((err) => isSimulacaoErrorCode(err.code))
      const errorMessage = apiError ? getSimulacaoErrorMessage(apiError.code) : 'Erro ao duplicar simulação'
      showToast({ message: errorMessage, variant: 'error', closeButton: true })
    },
  })
}
